import React from 'react';
//@ts-ignore
import MailCheck from 'react-mailcheck';
import { Input } from '..';
/**
 * EmailSuggestion.
 *
 * @param {IEmailSuggestionProps} props EmailSuggestion's props
 * @returns {React.FC<IEmailSuggestionProps>} Input with email suggestion.
 */
export var EmailSuggestion = function (options) {
    return (React.createElement(MailCheck, { email: options.email }, function (suggestion) { return (React.createElement(React.Fragment, null,
        React.createElement(Input, { label: options.label, defaultValue: options.defaultValue, error: options.error, onChange: options.onChange, testId: 'email', required: options.required, type: 'email', onKeyPress: options.onKeyPress }),
        suggestion && (React.createElement("span", { className: 'suggestion' }, options.suggestionMessage + " ",
            React.createElement("span", { className: 'suggestion-value', onClick: function () { return options.onChange(suggestion.full); } }, suggestion.full),
            "?")))); }));
};
//# sourceMappingURL=EmailSuggestion.js.map